import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const BlogDetailAtacama: React.FC = () => {
  const navigate = useNavigate();
  const { slug } = useParams();

  useEffect(() => {
    // Redirect to main blog detail page
    if (slug) {
      navigate(`/blog/${slug}/`);
    } else {
      navigate('/blog/?property=atacama');
    }
  }, [navigate, slug]);

  return null;
};

export default BlogDetailAtacama;